import { forwardRef } from "react";
import Table from "@/common/elements/Table";
import { getOptionsFromRefList } from "@/util/common_function";

// Exported so the parent (BookingQueueDetails/index.jsx) can pass this as
// the default to useGridColumnConfig without duplicating the column list.
export const BOOKING_QUEUE_HEADERS = [
  { key: "displayBookingQueueDetailID", text: "ID" },
  { key: "displayQueStepID", text: "Step" },
  { key: "displayComplete", text: "Complete" },
  { key: "completionDate", text: "Completion Date" },
  { key: "comments", text: "Comments" },
];

const BookingQueueTable = forwardRef(
  (
    {
      data,
      onRowClick,
      selected,
      onDoubleRowClick,
      headers = BOOKING_QUEUE_HEADERS,
      draggable = false,
    },
    ref
  ) => {
    // Get the list of step options
    const bookingQueueSteps = getOptionsFromRefList("BookingQueueStep", false, false, true);

    // Create a mapping of step IDs to step names
    const stepNameMap = bookingQueueSteps.reduce((acc, step) => {
      acc[step.value] = step.label;
      return acc;
    }, {});

    return (
      <Table
        ref={ref}
        headers={headers}
        draggable={draggable}
        selected={!!selected}
        data={data.map((row, index) => ({
          ...row,
          bookingQueueDetailID: row.bookingQueueDetailID || `new-${index}`, // Assign a temporary ID if undefined
          displayBookingQueueDetailID: row.bookingQueueDetailID || '',
          displayQueStepID: stepNameMap[row.queStepID] || row.queStepID, // Display step name
          displayComplete: row.complete ? "True" : "False",
        }))}
        onRowClick={(row) => {
          const originalRow = {
            ...row,
            queStepID: row.queStepID,
          };
          onRowClick(originalRow); // Pass the original row with the numeric queStepID
        }}
        onRowDoubleClick={(row) => {
          const originalRow = {
            ...row,
            queStepID: row.queStepID,
          };
          onRowClick(originalRow);
          onDoubleRowClick();
        }}
      />
    );
  }
);

export default BookingQueueTable;
